import { z } from 'zod';
// =============================================================================
// Membership Schema - Links Users to Organizations
// =============================================================================
/**
 * Membership role levels
 */
export const MembershipRoleEnum = z.enum(['OWNER', 'ADMIN', 'AGENT', 'VIEWER']);
/**
 * Role hierarchy for permission checking
 */
export const ROLE_HIERARCHY = {
    OWNER: 100,
    ADMIN: 75,
    AGENT: 50,
    VIEWER: 25,
};
/**
 * Full Membership schema (database document)
 */
export const MembershipSchema = z.object({
    _id: z.string(),
    userId: z.string(),
    organizationId: z.string(),
    role: MembershipRoleEnum.default('AGENT'),
    joinedAt: z.coerce.date(),
});
/**
 * Membership with populated user info
 */
export const MembershipWithUserSchema = MembershipSchema.extend({
    user: z.object({
        _id: z.string(),
        firstName: z.string(),
        lastName: z.string(),
        email: z.string(),
    }),
});
/**
 * Membership with populated organization info
 */
export const MembershipWithOrgSchema = MembershipSchema.extend({
    organization: z.object({
        _id: z.string(),
        name: z.string(),
        type: z.string(),
    }),
});
/**
 * Add member input
 */
export const AddMemberInputSchema = z.object({
    email: z.string().email(),
    role: MembershipRoleEnum.default('AGENT'),
});
/**
 * Update member role input
 */
export const UpdateMemberRoleInputSchema = z.object({
    role: MembershipRoleEnum,
});
/**
 * Helper to check if a role has sufficient permission level
 */
export function hasPermission(userRole, requiredRole) {
    return ROLE_HIERARCHY[userRole] >= ROLE_HIERARCHY[requiredRole];
}
//# sourceMappingURL=membership.js.map